<template>
    <span :style="{ color: nameColor }">{{ realname }}</span>
  </template>
  
  <script>
  export default {
    props: {
      realname: {
        type: String,
        required: true,
      },
      integral: {
        type: Number,
        required: true,
      },
    },
    computed: {
      nameColor() {
        // 根据积分返回颜色
        if (this.integral < 1500) {
          return 'white';  // 0 ~ 1500
        } else if (this.integral <= 5000) {
          return 'green';  // 1500 ~ 5000
        } else if (this.integral <= 10000) {
          return 'yellow'; // 5000 ~ 10000
        } else if (this.integral <= 15000) {
          return 'blue';   // 10000 ~ 15000
        } else if (this.integral <= 20000) {
          return 'purple'; // 15000 ~ 20000
        } else {
          return 'black';  // 默认颜色
        }
      },
    },
  };
  </script>
  
  <style>
  </style>
  